<style src="./Textarea.scss" lang="scss"></style>

<template lang="pug">
  .textarea(
    :class='classList'
  )
    textarea.textarea__field(
      @input='onInput'
      @focus='onFocus'
      v-model='fieldValue'
      ref='input'
      :type='fieldType'
      :name='name'
      :placeholder='placeholder'
      :required='required'
      v-shortkey.avoid
    )
</template>

<script>
export default {
  props: {
    value: {
      default: "text",
      type: String
    },
    type: {
      default: "text",
      type: String
    },
    name: {
      default: "",
      type: String
    },
    placeholder: {
      default: "",
      type: String
    },
    required: {
      default: false,
      type: Boolean
    },
    invalid: {
      default: false,
      type: Boolean
    },
    setFocus: {
      default: false,
      type: Boolean
    },
    onFocus: {
      default: () => {},
      type: Function
    }
  },
  data() {
    return {
      fieldValue: this.value,
      fieldType: this.type
    };
  },
  computed: {
    classList() {
      return {
        "is-visible": this.type === "password" && this.fieldType === "text",
        "is-invalid": this.invalid
      };
    }
  },
  methods: {
    onInput() {
      this.$emit("input", this.fieldValue);
    }
  },
  watch: {
    value(value) {
      this.fieldValue = value;
    }
  },
  mounted() {
    if (this.setFocus) {
      this.$refs.input.focus();
    }
  }
};
</script>
